<template>
  <div id="app">
    <NavBar />
    <router-view/>
  </div>
</template>

<script>
import "./assets/css/app.css";
import NavBar from './components/NavBar.vue'

export default {
  components: {
    NavBar
  }
}
</script>

<style>
@font-face {
  font-family: 'Axiforma-Regular';
  src: url('~@/assets/fonts/Axiforma-Regular.ttf');
}

#app {
  padding: 0px;
  margin: 0px;
  font-family: 'Axiforma-Regular';
  width: 100%;
  background-color: #EFF4FF;
}
</style>
